// extracted by mini-css-extract-plugin
export var banner = "custom-module--banner--1bkM2";
export var pageContainer = "custom-module--pageContainer--hxWt3";
export var container = "custom-module--container--3nxQw";
export var text = "custom-module--text--3-01U";
export var btn = "custom-module--btn--3kjcj";